/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";
console.log('JS loaded');

// import
import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import MouseFollower from "mouse-follower";
import Magnetic from "magnetic";
import {CountUp} from 'countup.js';

let imagesLoaded = require('imagesloaded');
gsap.registerPlugin(ScrollTrigger);
let nav = document.getElementById("mainNav");
let scrollTop = document.getElementById("scroll-top");

MouseFollower.registerGSAP(gsap);

const cursor = new MouseFollower({
    el: null,
    container: document.body,
    className: 'mf-cursor',
    innerClassName: 'mf-cursor-inner',
    textClassName: 'mf-cursor-text',
    mediaClassName: 'mf-cursor-media',
    mediaBoxClassName: 'mf-cursor-media-box',
    iconSvgClassName: 'mf-svgsprite',
    iconSvgNamePrefix: '-',
    iconSvgSrc: '',
    dataAttr: 'cursor',
    hiddenState: '-hidden',
    textState: '-text',
    iconState: '-icon',
    activeState: '-active',
    mediaState: '-media',
    stateDetection: {
        '-pointer': 'a,button',
        '-hidden': 'iframe'
    },
    visible: true,
    visibleOnState: false,
    speed: 0.55,
    ease: 'expo.out',
    overwrite: true,
    skewing: 0,
    skewingText: 0,
    skewingIcon: 2,
    skewingMedia: 2,
    skewingDelta: 0.001,
    skewingDeltaMax: 0.15,
    stickDelta: 0.15,
    showTimeout: 20,
    hideOnLeave: true,
    hideTimeout: 300,
    hideMediaTimeout: 300
});

document.addEventListener('DOMContentLoaded', function () {
    console.log('Init Scripts');
    const navbar = document.querySelector('.navbar');
    const menuBtn = document.getElementById('menu-burger');
    const sMenuBtn = gsap.utils.toArray('.menuItems .has-submenu');
    const b1 = document.querySelector('#menu-burger .b1');
    const b2 = document.querySelector('#menu-burger .b2');
    const overlay = document.getElementById('menu-overlay');
    const menuItems = gsap.utils.toArray('.menuItems .nav-item');

    let mm = gsap.matchMedia();
    let menuOpen = false;
    let navTl = null;
    const breakPoint = 1199;
    let isMobileG = false;
   // Splitting();

    mm.add({
        isDesktop: `(min-width: ${breakPoint}px)`,
        isMobile: `(max-width: ${breakPoint}px)`,
    }, (context) => {
        let {isDesktop, isMobile} = context.conditions;
        isMobileG = !!isMobile;
        // hide overlay
        gsap.set(overlay, {
            marginTop: isMobile ? "-100vh" : 0
        })

        // set menuItems
        gsap.set(menuItems, {
            opacity: isMobile ? 0 : 1
        })

        // overlay timeline
        navTl = gsap.timeline({
            defaults: {
                ease: 'power4.inOut',
                repeatRefresh: true,
            }
        });

        navTl
            .to(b1, {
                y: '-=5',
                duration: 0.2
            })
            .to(b2, {
                y: '+=5',
                duration: 0.2
            }, "-=0.2")
            .to(b1, {
                rotation: 45,
                transformOrigin: '50% 50%',
                duration: 0.3
            })
            .to(b2, {
                rotation: -45,
                transformOrigin: '50% 50%',
                duration: 0.3
            }, "-=0.3")
            .to(overlay, {
                marginTop: 0,
                duration: 0.5
            }, "-=0.5")
            .to(menuItems, {
                opacity: 1,
                stagger: 0.05,
                duration: 0.5
            }, "-=0.2")
        navTl.pause();
    })

    //  mousefollow + magnetic
    if (isMobileG) {
        cursor.destroy();
        [].forEach.call(sMenuBtn, function (btn) {
            btn.parentNode.querySelector('.back-sub').addEventListener('click', (evt) => {
                btn.parentNode.classList.remove('open')
            })
            btn.addEventListener('click', (evt) => {
                evt.preventDefault();
                if (btn.parentNode.classList.contains('open')) {
                    btn.parentNode.classList.remove('open')
                } else {
                    btn.parentNode.classList.add('open')
                }
            })
        })
    } else {
        const btns = document.querySelectorAll('.nav-item:not(.lang)');

        [].forEach.call(btns, function (btn) {
            // Init magnetic
            //new Magnetic(btn);
            btn.addEventListener('mouseenter', () => {
                cursor.addState('-nav');
                if (btn.classList.contains('subnav'))
                    navbar.classList.add("hover");
                cursor.setStick(btn);
            });

            btn.addEventListener('mouseleave', () => {
                cursor.removeState('-nav');
                navbar.classList.remove("hover");
                cursor.removeStick();
            });
        });
        const hide = document.querySelectorAll('main a:not(.btn)');
        [].forEach.call(hide, function (btn) {

            btn.addEventListener('mouseenter', () => {
                cursor.setStick(btn);
                cursor.addState('-hidden');
            });

            btn.addEventListener('mouseleave', () => {
                cursor.removeStick();
                cursor.removeState('-hidden');
            });
        });

        const mag = document.querySelectorAll('.stick-hide');
        [].forEach.call(mag, function (btn) {
            // Init magnetic
            new Magnetic(btn);
            btn.addEventListener('mouseenter', () => {
                cursor.setStick(btn);
                cursor.addState('-hidden');
            });

            btn.addEventListener('mouseleave', () => {
                cursor.removeStick();
                cursor.removeState('-hidden');
            });
        });

        const mag3 = document.querySelectorAll('footer a');
        [].forEach.call(mag3, function (btn) {
            // Init magnetic
            // new Magnetic(btn);
            btn.addEventListener('mouseenter', () => {
                cursor.setStick(btn);
                cursor.addState('-hidden');
            });

            btn.addEventListener('mouseleave', () => {
                cursor.removeStick();
                cursor.removeState('-hidden');
            });
        });

        const mag2 = document.querySelectorAll('.btn');
        [].forEach.call(mag2, function (btn) {
            // Init magnetic
            new Magnetic(btn);
            btn.addEventListener('mouseenter', () => {
                cursor.setStick(btn);
                cursor.addState('-hidden');
            });

            btn.addEventListener('mouseleave', () => {
                cursor.removeStick();
                cursor.removeState('-hidden');
            });
        });
    }

    const countUps = document.getElementsByClassName("count-up");
    [].forEach.call(countUps, function (countUpEl) {
        const countUp = new CountUp(countUpEl, countUpEl.dataset.num, {enableScrollSpy: true,separator:''});
        countUp.handleScroll();
    })

    // toggle menu
    menuBtn.addEventListener('click', (evt) => {
        evt.preventDefault();
        if (!menuOpen) {
            navTl.play();
            menuOpen = true;
        } else {
            navTl.reverse();
            menuOpen = false;
        }
    })

    // accordion
    const acc = document.getElementsByClassName("accordion");
    let i;

    for (i = 0; i < acc.length; i++) {

        acc[i].addEventListener("click", function () {
            this.classList.toggle("active");

            var panel = this.querySelector(".panel");

            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
            }

        });
    }

    // project swiper
    const swiper = new Swiper('.swiper-project', {
        modules: [Navigation, Pagination],
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        // parameters
        direction: 'horizontal',
        slidesPerView: 'auto',
        loop: false,
        freeMode: true,
        spaceBetween: 8
    });

    if (!isMobileG) {
        // Contains the items you want to parallax.
        const parallaxContainer = document.getElementById('parallax-container');

        if (parallaxContainer) {

            // The elements you want to parallax.
            let parallaxItems = parallaxContainer.getElementsByClassName('parallax');

            // Use this value to adjust the amount of parallax in response to mouse movement.
            var fixer = 0.0030;

            document.addEventListener("mousemove", function (event) {

                //console.log('mousemove')
                // get the mouseX - negative on left, positive on right
                var pageX = event.pageX - (parallaxContainer.getBoundingClientRect().width * 0.5);

                // same here, get the y. use console.log(pageY) to see the values
                var pageY = event.pageY - (parallaxContainer.getBoundingClientRect().height * 0.5);

                for (var $i = 0; $i < parallaxItems.length; $i++) {
                    var item = parallaxItems[$i];
                    var speedX = item.getAttribute("data-speed-x");
                    var speedY = item.getAttribute("data-speed-y");

                    // Instead of using 'TweenLite.set' you can use 'TweenLite.to' which results in a smoother initial transition (when the mouse enters) at the cost of some preformance.
                    // Change the '+' to '-' if you want to invert the parallax motion in relation to the mouse movement.
                    gsap.set(item, {
                        x: (item.offsetLeft + pageX * speedX) * fixer,
                        y: (item.offsetTop + pageY * speedY) * fixer
                    });
                }
            });
        }
    }

    if(document.querySelector(".hero")){
        const tilesContainer = document.querySelector('.tiles');
        if (tilesContainer) {
            for (let i = 0; i < 144; i++) {
                const tile = document.createElement('div');
                tile.classList.add('tile');
                tilesContainer.appendChild(tile);
            }
        }

        const chars = document.querySelectorAll(".hero-claim .char");
        gsap.set(
            chars,
            {
                opacity: 0,

                y: 0,
                x: 50,
            }
        );
    }

    imagesLoaded(document.querySelector("main"), function (instance) {
        const stl = gsap.timeline();
        stl.to('.loader', {opacity: 0, duration: 0.3}, '-=0');
        stl.to('.navbar', {opacity: 1, duration: 0.6}, '-=0');
        stl.to('main', {opacity: 1, duration: 0.6}, '-=0.3');
        stl.to('footer', {opacity: 1, duration: 0.6}, '-=0');

        if(document.querySelector(".hero")) {
            const chars = document.querySelectorAll(".hero-claim .char");
            const tl = gsap.timeline({
                delay: 1,
                onComplete:()=>{
                    const tlP = gsap.timeline({
                        scrollTrigger: {
                            trigger: ".navbar",
                            scrub: 0.1,
                            start: "top top",
                            end: "+=100%",
                            markers: false
                        }
                    });
                    if(document.querySelector(".hero .bg-img")){
                        tlP.to('.hero .bg-img', {
                            y: 200,
                            duration: 6
                        })
                    }

                    if(document.querySelector(".hero video")){
                        tlP.to('.hero video', {
                            y: 200,
                            duration: 6
                        })
                    }
                    tlP.to('.hero .gradient', {
                        height: "200%",
                        duration: 6
                    }, '-=6.0')
                  /*  if(document.querySelector(".hero .people")){
                        tlP.to('.hero .people', {
                            y: 50,
                            duration: 6
                        }, '-=6.0')
                    }*/
                    if(document.querySelector(".hero .tiles")){
                        tlP.to('.hero .tiles', {
                            y: 100,
                            duration: 6
                        }, '-=6.0')
                    }
                }
            });
        }
    })
});

// navbar shrink
window.addEventListener("scroll", function () {
    if (window.scrollY > 100) {
        scrollTop.classList.add('show')
        nav.classList.add("shrink");
    } else {
        scrollTop.classList.remove('show')
        nav.classList.remove("shrink");
    }
});

